import { render } from "./absence.vue?vue&type=template&id=20355b52&scoped=true"
import script from "./absence.vue?vue&type=script&lang=js"
export * from "./absence.vue?vue&type=script&lang=js"

import "./absence.vue?vue&type=style&index=0&id=20355b52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20355b52"]])

export default __exports__